var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 121,
    viewBox: "0 0 89 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 16,
    height: 107,
    fill: "#f75151"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 63,
    width: 16,
    height: 58,
    fill: "#122945"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 45,
    width: 16,
    height: 76,
    fill: "#f75151"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 0,
    width: 16,
    height: 121,
    fill: "#122945"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarGroup);
export default __webpack_public_path__ + "static/media/BarGroup.430169efcc9815c35b340ae2c9ffce90.svg";
export { ForwardRef as ReactComponent };